import React from 'react'
import FileInfoStyle from '../styles/FileInfoStyle'

export default function FileInfo({ fileInfo }) {
  return (
    <FileInfoStyle>
      {fileInfo.name ? (
        <div className="name">
          <div className="caption">NAZWA PLIKU</div>
          <div className="medium-emphasis-body-2">{fileInfo.name}</div>
        </div>
      ) : null}
      <div className="code">
        <div className="caption">KOD SYSTEMOWY</div>
        <div className="medium-emphasis-body-2">{fileInfo.code}</div>
      </div>
      <div className="variant">
        <div className="caption">WARIANT</div>
        <div className="medium-emphasis-body-2">
          {fileInfo.variant || '-'}
        </div>
      </div>
      <div className="version">
        <div className="caption">WERSJA SCHEMY</div>
        <div className="medium-emphasis-body-2">{fileInfo.version}</div>
      </div>
    </FileInfoStyle>
  )
}
